import { channel } from "@/lib/Types/Channel";

const CHECKOUT_ONLY_PARAMS = ["booking", "objectcode", "selectionid"];

export function buildBackToHotelUrl({
  searchParams,
  hotelCid,
  channel: channelValue,
}: {
  searchParams: URLSearchParams | Record<string, string>;
  hotelCid?: string | number;
  channel?: channel;
}): string {
  const params =
    searchParams instanceof URLSearchParams
      ? searchParams
      : new URLSearchParams(searchParams);
  const forwardedParams = new URLSearchParams();
  params.forEach((value, key) => {
    if (!CHECKOUT_ONLY_PARAMS.includes(key)) {
      forwardedParams.set(key, value);
    }
  });

  const queryString = forwardedParams.toString();
  const basePath = hotelCid
    ? `/hotel/hotel-cid_${hotelCid}`
    : `/${channelValue === channel.PACKAGE ? "urlaub" : "hotels"}/liste`;

  return queryString ? `${basePath}?${queryString}` : basePath;
}
